/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const UpdateEntityInputJsonApiModel = {
  id: "",
  entity: {
    jsonApi: "hasOne",
    type: "entities",
  },
  options: {
    jsonApi: "hasOne",
    type: "update-options",
  },
};
